import React, { useEffect, useState } from "react";
// import { useNavigate } from 'react-router'
import { useAuth } from "../config/authContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Menu from "../assets/images/menu.svg";

import ProfilePicture from "../assets/images/ProfilePicture.svg";

import Down from "../assets/images/down.svg";
import User from "../assets/images/User.svg";

import help from "../assets/images/help.svg";

import logoutIc from "../assets/images/logout.png";

import setting from "../assets/images/setting.png";
import right from "../assets/images/right.svg";
import mob from "../assets/images/mobilemenu.svg";
import Grouplogo from "../assets/images/Group.svg";

const Header = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { logout } = useAuth();
  const [crumbs, setCrumbs] = useState([]);
  const [user, setUser] = useState({});
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    setCrumbs(location.pathname);
    setUser(JSON.parse(localStorage.getItem("UserAccess")));
  }, [location]);

  const toggleLogic = () => {
    setToggle(!toggle);
    props.getSidebarToggleState(toggle);
  };
  useEffect(() => {}, []);

  const colorMap = {};
  const selectedColors = {};

  const generateColor = () => {
    let randomColorString = "#";
    const arrayOfColorFunctions = "0123456789abcdef";
    for (let x = 0; x < 6; x++) {
      let index = Math.floor(Math.random() * 16);
      let value = arrayOfColorFunctions[index];

      randomColorString += value;
    }
    return randomColorString;
  };
  const newColorFind = (id) => {
    if (colorMap[id]) return colorMap[id];
    let newColor;
    do {
      newColor = generateColor();
    } while (selectedColors[newColor]);
    colorMap[id] = newColor;
    selectedColors[newColor] = true;
    return newColor;
  };
  const getAvatar = (name) => {
    const fullName = name; // Replace with the full name you want to extract initials from

    // Split the full name into words
    const nameParts = fullName?.split(" ");

    let firstNameInitial = "";
    let lastNameInitial = "";

    // Check if there is at least one name part
    if (nameParts?.length > 0) {
      // Extract the first letter of the first name
      firstNameInitial = nameParts[0]?.charAt(0)?.toUpperCase();

      // Check if there is at least one more name part (last name or middle name)
      if (nameParts?.length > 1) {
        // Extract the first letter of the last name
        lastNameInitial = nameParts[nameParts?.length - 1]
          ?.charAt(0)
          ?.toUpperCase();
      } else if (nameParts[0].length > 1) {
        // If there's only one name part and it has more than one letter, take the first two letters as first name initials
        firstNameInitial = nameParts[0]?.substring(0, 2)?.toUpperCase();
      }
    }

    if (firstNameInitial !== "" && lastNameInitial !== "") {
      return <p>{firstNameInitial + lastNameInitial}</p>;
    } else {
      return <p>{firstNameInitial}</p>;
    }
  };
  function recrutingNav() {
    const link = document.createElement("a");
    link.href = "https://app.avenu.ai/";
    link.download = "avenu";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <header className="mainHeader">
      <div className="hd-left">
        <button
          className="menu-btn"
          onClick={() => {
            location.pathname ===
              "/dashboard/onboarding/onboarding-templates" ||
            location.pathname === "/dashboard/onboarding/templates"
              ? navigate()
              : location.pathname ===
                "/dashboard/onboarding/edit-onboarding-template"
              ? navigate("/dashboard/onboarding/onboarding-templates")
              : navigate(-1);
          }}
        >
          <img src={Menu} alt="test" className="menu_icon" />
        </button>
      </div>
      <nav aria-label="breadcrumb">
        {/* <ol className="breadcrumb">
                    {
                        <li className='form-name'>{crumbs === '/dashboard/onboarding/edit-forms' ? 'Onboarding Setup' : crumbs === '/dashboard/onboarding/create-form' ? 'Form Builder' : crumbs === '/dashboard/onboarding/edit-form' ? 'Form Builder' : crumbs === '/dashboard/upload' ? 'Convert PDF' : ''}</li>
                    }
                </ol> */}
      </nav>
      <div className="userarea">
        <div className="dropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="avatar " style={{ backgroundColor: "#41D1FF" }}>
              {user?.ProfileURL === null || user?.ProfileURL === "" ? (
                <p>{getAvatar(user?.user?.full_name)}</p>
              ) : (
                <div className="circle">
                  <img
                    className="logout-icon-img"
                    alt="Circular Image"
                    src={user?.ProfileURL}
                  />
                </div>
              )}
            </div>
            <span className="usernamelogout-arrow">
              {user?.user?.full_name}

              <img
                src={Down}
                alt="test"
                className="logout-arrow-img"
                style={{ width: "12px", marginLeft: "10px" }}
              />
            </span>
          </button>
          <ul className="dropdown-menu mt-1 profile-width">
            {/* <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse1" aria-expanded="false" aria-controls="flush-collapseOne"> */}
            {/* <li>
                            <a className="dropdown-item" href="#">
                                <img src={User} alt="test" className="menu_icon header-user-icon" />Edit Profile</a>
                            <img src={right} alt="test" className="rightarrow" />
                        </li> */}
            {/* </button> */}

            {/* <li> <a className="dropdown-item" href="#">
                            <img src={setting} alt="test" className="menu_icon header-user-icon" />

                            Settings</a> <img src={right} alt="test" className="rightarrow" /></li>

                        <li><a className="dropdown-item" href="#">
                            <img src={help} alt="test" className="menu_icon header-user-icon" />Help & Support

                        </a> <img src={right} alt="test" className="rightarrow" />
                        </li> */}

            <li>
              <Link
                className="dropdown-item"
                to="/"
                onClick={() => {
                  logout();
                  localStorage.clear();
                }}
              >
                <img
                  src={logoutIc}
                  alt="test"
                  className="menu_icon header-user-icon"
                />
                Logout
              </Link>
              <img src={right} alt="test" className="rightarrow" />
            </li>
          </ul>
        </div>
      </div>
      <button className="burgermenu" onClick={toggleLogic}>
        <img src={mob} alt="test" className="menu_icon" />
      </button>
    </header>
  );
};

export default Header;
